<button class="menu-list-item btn-clear" [disabled]="busy" (click)="download()">
  <div class="label">
    <ng-content></ng-content>
  </div>
  <mat-icon class="icon">download</mat-icon>
</button>
